import requirePropFactory from '@mui/utils/requirePropFactory';
export default requirePropFactory;